import React from "react";
import { useDropzone } from "react-dropzone";
import {
  Alert,
  Link,
} from "@mui/material";

import FormDialog from "../../../../../components/Dialog/FormDialog";
import { CustomButton } from "../../../../../components/Button/Button";
import downloadTemplate from "../../../../../styles/svg/download-attachment.svg";
import uploadCloudImg from "../../../../../styles/svg/uploadCloudCSV.svg";
import ImportUsersFromCSV from "./ImportUsersFromCSV";
import { useUploadUserCSV } from "./hooks/useUploadUserCSV";
import "./styles/UploadUserCSV.scss";

export default function UploadUserCSV({ open, onClose }) {
  const {
    errorMessage,
    handleClose,
    handleFiles,
    handleImportUsersClose,
    handleTemplateDownload,
    hasInvalidRows,
    isSubmitting,
    openImportUsers,
    previewRows,
    submitFileUpload,
  } = useUploadUserCSV({ onClose });

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "text/csv": [".csv"],
    },
    multiple: false,
    onDrop: handleFiles,
  });

  return (
    <>
      {openImportUsers && (
        <ImportUsersFromCSV
          errorMessage={errorMessage}
          hasInvalidRows={hasInvalidRows}
          isSubmitting={isSubmitting}
          onClose={handleImportUsersClose}
          onSubmit={submitFileUpload}
          open={openImportUsers}
          previewRows={previewRows}
        />
      )}
      <FormDialog
        open={open}
        handleClose={handleClose}
        title={"Upload File"}
        fullWidth={true}
        width={749}
      >
        <div className="upload-user-csv">
          {errorMessage && <Alert severity="error">{errorMessage}</Alert>}

          <div
            className={`upload-user-csv-box ${isDragActive ? "drag-active" : ""}`}
            {...getRootProps()}
          >
            <input {...getInputProps()} />
            <img src={uploadCloudImg} alt="Upload CSV" />
            <div className="p-1">Select a File and drag and drop here</div>
            <div className="p-2">We Support CSV file here</div>
            <CustomButton className="select-file-btn">
              <input
                type="file"
                hidden
                accept=".csv"
                onChange={(event) => handleFiles(event.target.files)}
              />
              SELECT FILE
            </CustomButton>
          </div>

          <div className="template-download-row">
            <img src={downloadTemplate} alt="" className="mr-2" />
            <Link component="button" variant="body2" onClick={handleTemplateDownload}>
              Download Template
            </Link>
          </div>
        </div>
      </FormDialog>
    </>
  );
}
